import { atom } from 'recoil';

export const isAmbientListeningActive = atom({
  key: 'isAmbientListeningActive',
  default: false
});

export const enhanceAmbientListeningLoading = atom({
  key: 'enhanceAmbientListeningLoading',
  default: false
});

export const ambientListeningIntelligenceChatId = atom({
  key: 'ambientListeningIntelligenceChatId',
  default: null
});

export const enhancedNote = atom({
  key: 'enhancedNote',
  default: null
});

export const isAmbientNoteEdited = atom({
  key: 'isAmbientNoteEdited',
  default: false
});

export const emCPTsText = atom({
  key: 'emCPTsText',
  default: null
});

export const currentActiveStepID = atom({
  key: 'currentActiveStepID',
  default: 1
});

export const transcriptionLoading = atom({
  key: 'transcriptionLoading',
  default: false
});

export const isTranscriptionCreated = atom({
  key: 'isTranscriptionCreated',
  default: null
});

export const transcriptions = atom({
  key: 'transcriptions',
  default: []
});

export const selectedNoteType = atom({
  key: 'selectedAmbientListeningNoteType',
  default: null
});

export const preSelectedNoteType = atom({
  key: 'preSelectedAmbientListeningNoteType',
  default: null
});

export const additionalProviderNotesState = atom({
  key: 'additionalProviderNotesState',
  default: ''
});
